import React from "react";

function AccordionArrowOpenClose({ style, className }: { style?: React.CSSProperties, className?: string }) {
  return (
    <svg
      width="21"
      height="21"
      viewBox="0 0 24 24"
      style={style}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>AccordionArrowOpenClose</title>
      <path
        d="M12 16.2361L2.8537 6.65346C2.65852 6.44897 2.34194 6.44883 2.1466 6.65315C1.95125 6.85747 1.95112 7.18887 2.1463 7.39336L11.6463 17.3465C11.8416 17.5512 12.1584 17.5512 12.3537 17.3465L21.8537 7.39336C22.0489 7.18887 22.0487 6.85747 21.8534 6.65315C21.6581 6.44883 21.3415 6.44897 21.1463 6.65346L12 16.2361Z"
      />
    </svg>
  );
}

export default AccordionArrowOpenClose;
